import {BaseEntity} from "./BaseEntity";

export class PrintJob implements BaseEntity {
    constructor(public id?: number,
                public recordID?: number,
                public tableName?: string,
        public templateID?: number,
        public useWithService?: string,
        public assetName?: string,
        public locationName?: string,
        public templateName?: string,
        public message?: string,        
        public created?: string,
        public generatedRfid?: string,
        public completed: boolean = false) {
    }

    parseJson(json: any): void {
        this.id = json.id;
        this.recordID = json.recordID;
        this.tableName = json.tableName;
        this.templateID = json.templateID;
        this.completed = json.completed;
        this.assetName = json.assetName;
        this.locationName = json.locationName;
        this.templateName = json.templateName;
        this.message = json.message;
        this.created = json.created;
        this.generatedRfid = json.generatedRfid;
        this.useWithService = json.useWithService;
    }
}
